import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import getYear from 'date-fns/getYear';

import Logo from '@giro/shared-components/Logo.component';
import ROUTES from '@giro-app/constants/routes.constant';

const FooterComponent = (props) => {
  return (
    <Box
      component="footer"
      display="flex"
      alignItems="center"
      justifyContent="center"
      minHeight={190}
      py={4}
      px={2}
      bgcolor="primary.main"
      {...props}
    >
      <Box display="flex" alignItems="center" flexDirection="column" gap={2}>
        <Logo variant="new-sym" width="80" />
        <Box
          display="flex"
          flexDirection="column"
          sx={{
            color: 'primary.main',
          }}
          gap={1}
        >
          <Typography align="center" variant="subtitle1" color="white">
            Giro Pagamentos e Tecnologia Ltda. <br />
            CNPJ: 23.041.219/0001-34
          </Typography>
          <Typography align="center" variant="subtitle1" color="white">
            Copyright © {getYear(new Date())} Giro Pagamentos.
          </Typography>
        </Box>
        <Box
          component="nav"
          aria-label="Documentos legais"
          display="flex"
          flexWrap="wrap"
          justifyContent="center"
          gap={2}
        >
          <Link
            href={ROUTES.EXTERNAL.SITE.PRIVACY_POLICY}
            color="common.white"
            variant="subtitle2"
            underline="always"
          >
            Política de Privacidade
          </Link>
          <Link
            href={ROUTES.EXTERNAL.SITE.TERMS_OF_USE}
            color="common.white"
            variant="subtitle2"
            underline="always"
          >
            Termos de Uso
          </Link>
        </Box>
      </Box>
    </Box>
  );
};

export default FooterComponent;
